import { render, staticRenderFns } from "./LmsFeedMore.vue?vue&type=template&id=760d50e2"
import script from "./LmsFeedMore.vue?vue&type=script&lang=js"
export * from "./LmsFeedMore.vue?vue&type=script&lang=js"
import style0 from "./LmsFeedMore.vue?vue&type=style&index=0&id=760d50e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports